var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_container"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChange}}),(_vm.pdfBytes)?_c('pdf',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.pdfBytes},on:{"progress":_vm.onProgress,"loaded":_vm.onLoaded,"error":_vm.onError}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }